import React from 'react';
import { Col, Row, Button } from "antd";
import { ParagraphHeader } from "@seims/shared";
import eventLandingImage from "../../assets/events-landing-page.webp";
import { screen } from '@testing-library/react';

export const EventsLandingPage = () => {
  return (
    <div style={{ padding: "24px 0 12px" }}>
      <Row>
        <Col xs={24}>
          <ParagraphHeader header="Events App" />
          <Row
            gutter={[24, 24]}
            className="justift-text"
            style={{
              justifyContent: "center",
              padding: "10px 12px 0"
            }}
          >
            <Col xs={24} md={20} lg={16}>
              <img
                src={eventLandingImage}
                alt="SEIMS events landing"
                style={{
                  width: "100%",
                  // minHeight: "240px",
                  // maxHeight: "420px",
                  // objectFit: "cover",
                  borderRadius: "4px",
                  boxShadow: "0 10px 10px rgba(11,74,124,0.18)"
                }}
              />
            </Col>
            <Col xs={24} md={20} lg={16}>
              <div className="public-portal-section-text" style={{ padding: "0 8px 8px" }}>
                <p>
                  Science engagement and related event organisers can now effortlessly register their events
                  and collect participant data with the help of the SEIMS Events App.
                  You can view real-time event data and participation analytics through the SEIMS Events app.
                </p>
              </div>
            </Col>
          </Row>
          <Row
            gutter={[24, 24]}
            className="justift-text"
            style={{
              justifyContent: "center",
              padding: "10px 12px 0"
            }}
          >
            {/* <Col xs={24} md={20} lg={16} style={{ textAlign: "center" }}>
            <ParagraphHeader header="Download SEIMS Events App" />
            <div  style={{ padding: "0 8px 8px" }}>
                <p>
                  Click to download the App your home screen
                </p>
              </div>
              <Button type="primary">Events App</Button>
            </Col> */}
          </Row>
        </Col>
      </Row>
    </div>
  )
}
